import {
    FETCH_INVOICES, ADD_INVOICE, 
    UPDATE_INVOICE,
    DELETE_INVOICES,
    FETCH_SINGLE_INVOICE, 
    CREATE_PROPERTY_INVOICES,
    CREATE_RECURRING_BILLS_INVOICES,
    BULK_ADD_INVOICES,
    CALCULATE_BULK_INVOICES,
    CREATE_BULK_INVOICES
} from './actionTypes';


export const fetchInvoices = (params={tenantIds:[], propertyIds:[], unitIds:[], 
    startDate: "", endDate:"", status:[],invoiceItem:"", offset:"", searchtext: ""
}) => {
        return ({
            type: FETCH_INVOICES,
            payload: {
                ...params
            }
        });
}

export const fetchSingleInvoice = (invoiceId) => {
        return ({
            type: FETCH_SINGLE_INVOICE,
            payload: {
                invoiceId
            }
        });
}


export const addInvoice = ({tenantId, amount, memo, invoiceItems, status, invoiceDate, combineWithOtherInvoices}, 
    addToOrder=true
) => ({
    type: ADD_INVOICE,
    payload: {
        invoice: {
            description: memo,
            invoiceItems,
            tenantId, 
            amount,
            status: status,
            invoiceDate,
            combineWithOtherInvoices
        },
        addToOrder: addToOrder
    },
});

export const updateInvoice = ({
    invoiceId, tenantId, amount, memo, invoiceItems, status, invoiceDate,
    combineWithOtherInvoices
}) => ({
    type: UPDATE_INVOICE,
    payload: {
        invoice: {
            invoiceId,
            tenantId, 
            amount, 
            description: memo, 
            invoiceItems,
            status,
            invoiceDate,
            combineWithOtherInvoices
        }
    }
});

export const deleteInvoices = (invoiceIds) => ({
    type: DELETE_INVOICES,
    payload: {
        invoiceIds
    }
});

export const createPropertyInvoices = (propertyIds) => ({
    type: CREATE_PROPERTY_INVOICES,
    payload: {
        propertyIds
    },
    errors: null
});

export const createRecurringBillsInvoices = (propertyIds, tenantIds, unitIds) => ({
    type: CREATE_RECURRING_BILLS_INVOICES,
    payload: {
        propertyIds,
        tenantIds,
        unitIds
    },
    errors: null
});

export const bulkAddInvoices = (invoices) => ({
    type: BULK_ADD_INVOICES,
    payload: {
        invoices
    }
})

export const calculateBulkInvoices = ({ propertyIds, invoiceDate, invoiceItems }) => ({
    type: CALCULATE_BULK_INVOICES,
    payload: { propertyIds, invoiceDate, invoiceItems },
    errors: null
});

export const createBulkInvoices = (invoiceInputs) => ({
    type: CREATE_BULK_INVOICES,
    payload: {
        invoiceInputs
    },
    errors: null
});